/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trialSkillRecommendationsControllerCreate } from "./trialSkillRecommendationsControllerCreate";

export function trialOnboardingSkillRecommendationsService() {
  return { trialSkillRecommendationsControllerCreate }
}